const OfferValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }
  if (!values.offer_condition_id) {
    // You can return translation keys
    errors.offer_condition_id = "Condition is required";
  }
  if (!values.condition_value && values.condition_value !== 0) {
    // You can return translation keys
    errors.condition_value = "Value is required";
  }
  if (!values.coupon_id) {
    // You can return translation keys
    errors.coupon_id = "Benefit is required";
  }
  if (!values.coupon_value && values.coupon_value !== 0) {
    // You can return translation keys
    errors.coupon_value = "Value is required";
  }

  // if (!values.authorize_pin) {
  //   // You can return translation keys
  //   errors.authorize_pin = "PIN is required";
  // }

  return errors;
};

export default OfferValidation;
